import type { EndpointMeta } from "@/apis/types";
import {
  createFetchAndHook,
  type FetchFactory,
  type HookFactory,
} from "@/shared/factories";
import { wsdotTollRatesApiMeta } from "../apiMeta";
import {
  type TollTripRatesInput,
  tollTripRatesInputSchema,
} from "./shared/tollTripRates.input";
import {
  type TollTripsRates,
  tollTripsRatesSchema,
} from "./shared/tollTripRates.output";

/**
 * Metadata for the fetchTollTripRates endpoint
 */
export const tollTripRatesMeta = {
  functionName: "fetchTollTripRates",
  endpoint: "/getTollTripRatesAsJson",
  inputSchema: tollTripRatesInputSchema,
  outputSchema: tollTripsRatesSchema,
  sampleParams: {},
  endpointDescription: "Get current toll rates for all trips.",
} satisfies EndpointMeta<TollTripRatesInput, TollTripsRates>;

/**
 * Fetch function for retrieving current toll rates for all trips
 */
const { fetch, useHook } = createFetchAndHook<
  TollTripRatesInput,
  TollTripsRates
>({
  api: wsdotTollRatesApiMeta,
  endpoint: tollTripRatesMeta,
  getCacheStrategy: () =>
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require("./shared/tollTripRates.endpoints").tollTripRatesGroup
      .cacheStrategy,
});

/**
 * Fetch function for retrieving current toll rates for all trips
 */
export const fetchTollTripRates: FetchFactory<
  TollTripRatesInput,
  TollTripsRates
> = fetch;

/**
 * React Query hook for retrieving current toll rates for all trips
 */
export const useTollTripRates: HookFactory<TollTripRatesInput, TollTripsRates> =
  useHook;
